/** Parse compact server→CLI heartbeat ack `{ t: 'ha', s: number }` from a raw WebSocket frame. */
export function tryParseCompactHeartbeatAck(raw: unknown): number | null {
  let str: string | null = null;
  if (typeof raw === 'string') {
    str = raw;
  } else if (Buffer.isBuffer(raw)) {
    str = raw.toString('utf8');
  } else if (raw instanceof ArrayBuffer) {
    str = Buffer.from(raw).toString('utf8');
  } else {
    return null;
  }
  if (str.length > 64 || !str.includes('"ha"')) return null;
  try {
    const parsed: unknown = JSON.parse(str);
    if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
    const o = parsed as Record<string, unknown>;
    if (o.t !== 'ha') return null;
    const s = o.s;
    if (typeof s !== 'number' || !Number.isFinite(s)) return null;
    return Math.trunc(s);
  } catch {
    return null;
  }
}
